'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
var $ = require("jquery");
var Youtube;
(function (Youtube) {
    var MyYoutube = /** @class */ (function () {
        function MyYoutube() {
            this.underSpWidth = 767;
            this.pcYouTubeID = 'oMNob-47Q7k';
            this.spYouTubeID = 'oMNob-47Q7k';
            // 画面サイズ
            this.wins = { w: 0, h: 0 };
            var self = this;
            // this.changeSpFirstView();
            // this.changeMainVisual();
            this.resizePlayer();
            $(window).resize(function () {
                //this.changeSpFirstView();
                // self.changeMainVisual();
                self.resizePlayer();
            });
        }
        // ファーストビュースマホのサイズ変更
        MyYoutube.prototype.changeSpFirstView = function () {
            if (this.isSpWidth()) {
                var projectHeight = $('.paramProject').outerHeight();
                $('#bulletYouTube').css('height', projectHeight);
            }
        };
        //プレイ準備完了後
        MyYoutube.prototype.onPlayerReady = function (event) {
            event.target.playVideo();
            event.target.mute();
            $('#bulletYouTube').css('background-image', 'none');
        };
        // PCトップ動画サイズ
        MyYoutube.prototype.resizePlayer = function () {
            this.wins.w = $(window).width();
            if ($('#bulletYouTubePlayer').length > 0) {
                // this.wins.h = $(window).height();
                this.wins.h = $('.paramProject').height();
                if (this.wins.h < 667) {
                    this.wins.h = 667;
                }
                this.heightDiff = this.wins.h;
                this.ratio = this.wins.h / this.wins.w;
                /**
                 * Youtube iframe の位置サイズを決定
                 * 幅, 高さ, marginTop, marginLeft
                 */
                var yt = { w: this.wins.w, h: this.wins.h, mt: 0, ml: 0 };
                if (this.ratio > 0.5625) {
                    yt.w = yt.h / 0.5625;
                    yt.ml = -Math.floor((yt.w - this.wins.w) / 2);
                }
                else if (this.ratio < 0.5625) {
                    yt.h = yt.w * 0.5625;
                    yt.mt = -Math.floor((yt.h - this.wins.h) / 2);
                }
                // YouTubeの位置変更パラメータ
                var changeWidth = yt.w;
                var changeMarginLeft = yt.ml;
                if (this.isSpWidth()) {
                    changeMarginLeft = yt.ml;
                }
                $('#bulletYouTubeBox').css({
                    width: changeWidth,
                    marginTop: yt.mt,
                });
                $('#bulletYouTubeBoxContent').css({
                    marginLeft: changeMarginLeft,
                });
                $('#bulletYouTube').css({
                    'height': this.heightDiff,
                });
            }
        };
        /*
        public changeMainVisual(): void {
            const self = this;

            let movieId = self.pcYouTubeID;
            if( this.isSpWidth() ) {
                movieId = self.spYouTubeID;
            }

            YouTubeIframeLoader.load(function(YT) {
                self.player = new YT.Player(
                    'bulletYouTubePlayer', // 埋め込む場所の指定
                    {
                        videoId: movieId, // YouTubeのID
                        playerVars: {
                            rel: 0, // 再生終了後に関連動画を表示するかどうか設定
                            loop: 0,//0:ループしない 1:ループする 1の場合playlist設定必須
                            playlist: movieId,//次に流すYoutubeのID
                            controls: 0,//コントローラー無し
                            autoplay: 1,//オートプレイ
                            showinfo: 0,//動画タイトルなど表示しない
                            playsinline: 1
                        },
                        events: {
                            'onReady': self.onPlayerReady
                        }
                    }
                );
            });
        }
         */
        MyYoutube.prototype.isSpWidth = function () {
            var isSpWidth = false;
            var browserWidth = $(window).outerWidth();
            if (browserWidth <= this.underSpWidth) {
                isSpWidth = true;
            }
            return isSpWidth;
        };
        return MyYoutube;
    }());
    Youtube.MyYoutube = MyYoutube;
})(Youtube || (Youtube = {}));
exports.default = Youtube;
